import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { getContentPath } from '../../common/ContentPaths';
import PublicationLink from '../publication/PublicationLink';
import ContentViewerLink from './ContentViewerLink';
import WorkflowViewerAuthorLink from './WorkflowViewerAuthorLink';
import { isContentInTechWriterReview } from '../../api/ContentUtil';
import { Button } from '@amzn/awsui-components-core';

class AuthorContentViewerLink extends React.Component<{ contentWorkflow: ContentWorkflow }> {
  public render() {
    const { contentId, publicationWorkflowId, draftContentMetadata, draftState, publicationState } =
      this.props.contentWorkflow;
    if (isContentInTechWriterReview(this.props.contentWorkflow)) {
      return (
        <div>
          <ContentViewerLink contentId={contentId} metadata={draftContentMetadata} />
        </div>
      );
    }
    if (
      [
        WorkflowState.PUBLISHED,
        WorkflowState.FINALIZING,
        WorkflowState.FINALIZED,
        WorkflowState.DISTRIBUTED,
        WorkflowState.REVOKED,
        // @ts-expect-error TS2345 - strict migration
      ].includes(publicationState)
    ) {
      const editingLink = this.isContentInPublisherReview(draftState)
        ? getContentPath({ contentId, mode: 'draft', role: 'read-only' })
        : getContentPath({ contentId, mode: 'draft', role: 'author' });
      return (
        <div>
          <PublicationLink
            contentId={contentId}
            workflowId={publicationWorkflowId}
            contentName={draftContentMetadata.contentName}
          />
          <Button href={editingLink} variant="link" iconName="edit" ariaLabel="Edit content" />
        </div>
      );
    }

    if (this.isContentInPublisherReview(draftState)) {
      return <ContentViewerLink contentId={contentId} metadata={draftContentMetadata} />;
    }

    return <WorkflowViewerAuthorLink contentId={contentId} metadata={draftContentMetadata} />;
  }

  private isContentInPublisherReview = (state: WorkflowState) => {
    return [WorkflowState.REVIEWED].includes(state);
  };
}

export default AuthorContentViewerLink;
